import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ChevronDownIcon = forwardRef((props, ref) => {
    return (jsx(SvgIcon, Object.assign({}, props, { ref: ref }, { children: jsxs("svg", Object.assign({ "data-name": "Icons / chevron-down", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, { children: [jsx("path", { "data-name": "Path 399", d: "M0 0h24v24H0z", fill: "none" }), jsx("path", { "data-name": "Path 400", d: "m6 9 4 4 4-4", transform: "translate(2 1)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5px", fill: "none" })] })) })));
});

export { ChevronDownIcon };
//# sourceMappingURL=ChevronDownIcon.js.map
